export const REMINDERS_PAUSED_REASONS = {
  quota: 'quota',
  subscriptionEnded: 'subscription_ended',
  paymentPaused: 'payment_paused',
} as const;

export type RemindersPausedReason =
  (typeof REMINDERS_PAUSED_REASONS)[keyof typeof REMINDERS_PAUSED_REASONS];
